export default theme => ({
	root: {
		fontWeight: 'bold',
	},
});
